import ApiService from '@shared/services/api.service';

const endPoint = '/contacts';

const ContactService = {
  getList() {
    return ApiService.get(endPoint);
  },

  create(bodyParams) {
    return ApiService.post(`${endPoint}`, bodyParams);
  },

  update(contact, bodyParams) {
    return ApiService.put(`${endPoint}/${contact}`, bodyParams);
  },

  get(contact) {
    return ApiService.get(`${endPoint}/${contact}`);
  },

  delete(contact) {
    return ApiService.delete(`${endPoint}/${contact}`);
  }
};
export default ContactService;
